import './style.scss';
import WorkstreamFilters from './workstreamFilters.component';

export default WorkstreamFilters;
